import { render } from "./TipiManutenzione.vue?vue&type=template&id=119a0e5c"
import script from "./TipiManutenzione.vue?vue&type=script&lang=js"
export * from "./TipiManutenzione.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__